module.exports = __webpack_public_path__ + "static/media/ic_pagination_ellipsis.f169513b.svg";